__turbopack_context__.v({
  "cartEmptyState": "_5QjBIG_cartEmptyState",
  "tabletContent": "_5QjBIG_tabletContent",
  "wrapper": "_5QjBIG_wrapper",
  "wrapperModal": "_5QjBIG_wrapperModal",
});
